import { Container, Stack, Text, Title } from '@mantine/core'
import { StoryCatalog } from '../components/landing/StoryCatalog'
import { RevisitBanner } from '../components/landing/RevisitBanner'
import { TeamPlayBanner } from '../components/teams/TeamPlayBanner'

export default function Landing() {
  return (
    <Container size="lg" py="xl">
      <Stack gap="xl">
        {/* Hero */}
        <Stack align="center" gap="sm" py="xl">
          <Title
            order={1}
            ff="var(--bw-heading-font)"
            ta="center"
            className="glow-text-cyan"
            fz={{ base: '2rem', sm: '2.5rem' }}
            style={{ color: 'var(--bw-accent)' }}
          >
            Choose Your Story
          </Title>
          <Text
            c="dimmed"
            size="lg"
            ta="center"
            maw={500}
          >
            Interactive stories where your choices shape the narrative.
            Step into worlds crafted for learning and discovery.
          </Text>
        </Stack>

        {/* Steer team players to their team before they pick a solo story */}
        <TeamPlayBanner />

        {/* Let returning students revisit a finished story and keep chatting */}
        <RevisitBanner />

        {/* Story grid */}
        <StoryCatalog />
      </Stack>
    </Container>
  )
}
